/**
 * @fileoverview Custom OpenLayers control for displaying a world information button.
 * @module map/InfoButtonControl
 */

/**
 * Custom OpenLayers control that provides an [i] button at the bottom-right of the map.
 * When clicked, triggers the onInfo callback to display world information.
 * @class
 * @extends ol.control.Control
 */
export class InfoButtonControl extends ol.control.Control {
    /**
     * Creates a new InfoButtonControl instance.
     * @param {Object} [options={}] - Control options
     * @param {Function} [options.onInfo] - Callback invoked when info button is clicked
     * @param {HTMLElement} [options.target] - Target element to render the control into
     */
    constructor(options = {}) {
        const button = document.createElement('button');
        button.innerHTML = '<i class="bi bi-info-circle"></i>';
        button.className = 'ol-info-button';
        button.title = 'World information';

        const element = document.createElement('div');
        element.className = 'ol-info-button-control ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target
        });

        this.onInfo = options.onInfo || (() => {});

        // Handle button click
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onInfo();
        });
    }
}
